import React, {useState, useEffect} from 'react';
import {useInView} from 'react-intersection-observer';
import ContentLoader from 'react-content-loader';

import Button from 'components/button/Button';
import {useAppDispatch, useAppSelector} from 'utils/hooks';
import {ICardData, setActiveCategory, setChangeSearchData} from 'store/components/PrizesSlice';

import {GetIcon } from 'store/enums/normalizedIcons';

interface CardItemProps {
  card_data: ICardData;
  index: number;
  step: number;
  mode: string;
  defaultImg: string;
  showOrderCard: (guid: string) => void;
  liRef?: React.RefObject<HTMLLIElement>;
}

const CardItem = ({ card_data, index, step, mode, defaultImg, showOrderCard, liRef }: CardItemProps) => {
  const dispatch = useAppDispatch();
  const { ref: inViewRef, inView } = useInView({
    triggerOnce: true,
    threshold: 0.2,
  });

  const categories = useAppSelector(state => state.prizes.categories);
  const colors = useAppSelector((state) => state.settings.colors);
  const domain = useAppSelector((state) => state.settings.currentDomainName);
  const cart = useAppSelector(state => state.cart.normalizedData);
  
  const [isImageLoading, setIsImageLoading] = useState(true);
  
  const in_cart = cart && cart[card_data.guid_1c];
  const src = card_data.file_link ? card_data.file_link : defaultImg;
  const isLoadedAndHidden = isImageLoading || !inView;

  const clickCategory = (event: any, category: string) => {
    const index = categories.findIndex((item) => item.name === category);
    dispatch(setChangeSearchData(true));
    setTimeout(() => {
      dispatch(setChangeSearchData(false));
    }, 0);
    if (index > 0) {
      dispatch(setActiveCategory(index));
    }
    event.stopPropagation();
  };

  useEffect(() => {
    if (inView && src) {
      setIsImageLoading(false);
    }
  }, [src, inView]);

  return (
    <li
      ref={index === (step + 1) * 19 - 1 && liRef ? liRef : inViewRef}
      key={card_data.id}
      onClick={() => showOrderCard(card_data.guid_1c)}
      className={'prizes-cards__item prizes-cards__item_active'}>
      <div className={'prizes-cards__item-container'}>
        <div>
          <div className={'prizes-cards__image-container'}>
            {isLoadedAndHidden ? (
              <ContentLoader 
                speed={2}
                width='100%'
                height='100%'>
                <rect x="0" y="0" rx="8" ry="8" width="100%" height="100%" /> 
              </ContentLoader>
            ) : (
              <>
                {mode === 'plastic' ? <span className={'prizes-cards__plastic-tip'}>Пластик</span> : null}
                <img 
                  src={src} 
                  alt='cards-logo'
                  loading="lazy"
                  className={'prizes-cards__image'}
                  onLoad={() => setIsImageLoading(false)}
                />
              </>
            )}
          </div>
          <div className={'prizes-cards__content'}>
            {isLoadedAndHidden ? (
              <ContentLoader 
                speed={2}
                width='100%'
                height='32px'>
                <rect x="0" y="0" rx="4" ry="4" width="90%" height="14px" /> 
              </ContentLoader>
            ) : <h3 className={'prizes-cards__title'}>{card_data.name}</h3>}
          </div>
        </div>
        <div className={'prizes-cards__content'} onClick={e => e.stopPropagation()}>
          {isLoadedAndHidden ? (
            <ContentLoader 
              speed={2}
              width='100%'
              height='28px'>
              <rect x="0" y="0" rx="4" ry="4" width="80%" height="16px" /> 
            </ContentLoader>
          ) : (
            <p className={'prizes-cards__subtitle prizes-cards__subtitle_desktop'}>Категория:&nbsp;
              <span
                onClick={(event) => clickCategory(event, card_data.category)}
                className={'prizes-cards__subtitle prizes-cards__category'}>
                {card_data.category}
              </span>
            </p>
          )}
          {isLoadedAndHidden ? (
            <ContentLoader 
              speed={2}
              width='100%'
              height='38px'>
              <rect x="0" y="0" rx="4" ry="4" width="100%" height="100%" /> 
            </ContentLoader>
          ) : (
            <Button
              width={'100%'}
              className={`prizes-cards__button ${in_cart || card_data.in_cart ? 'prizes-cards__button-icon' : ''}`}
              onClick={() => showOrderCard(card_data.guid_1c)}>
              {in_cart || card_data.in_cart ? <GetIcon iconName={'InCart'} fill={colors[domain].firstColorIconActive} /> : 'Выбрать номинал'}
            </Button>
          )}
        </div>
      </div>
      <div className={'prizes-cards__button-container'} onClick={e => e.stopPropagation()}>
        <p className={'prizes-cards__subtitle prizes-cards__subtitle_mobile '}>Категория:&nbsp;
          <span
            onClick={(event) => clickCategory(event, card_data.category)}
            className={'prizes-cards__subtitle prizes-cards__category'}>
            {card_data.category}
          </span>
        </p>
        {isLoadedAndHidden ? (
          <ContentLoader 
            speed={2}
            width='100%'
            height='22px'>
            <rect x="0" y="0" rx="4" ry="4" width="100%" height="100%" /> 
          </ContentLoader>
        ) : (
          <Button
            borderRadius={5}
            className={`
              prizes-cards__button
              prizes-cards__button_mobile
              ${in_cart || card_data.in_cart ? 'prizes-cards__button-icon' : ''}
            `}
            onClick={() => showOrderCard(card_data.guid_1c)}>
            {in_cart || card_data.in_cart ? <GetIcon iconName={'InCart'} fill={colors[domain].firstColorIconActive}  /> : 'Выбрать номинал'}
          </Button>
        )}
      </div>
    </li>
  );
};

export default CardItem;